<template>
  <div class="widget_upload">
    <div class="upload-action">
      <file-upload
        ref="upload"
        :input-id="id"
        v-model="files"
        name="file"
        :multiple="multiple"
        :post-action="url"
        :size="maxsize"
        :maximum="maximum"
        @input-file="inputFile"
        @input-filter="inputFilter"
        @input="updatetValue"
        :headers="{}"
      >
        <slot></slot>
      </file-upload>
    </div>
    <div class="uploads-preview">
      <div class="uploading-list">
        <template v-for="(file, index) in files">
          <div
            class="uploading-item"
            :key="index + 'add'"
            :class="{ error: file.error, success: file.success }"
            v-if="isImage(file.name)"
          >
            <img :src="file.blob" />
            <button
              v-if="!file.success"
              @click="removeFile(file, 'add')"
              class="btn-remove"
            >
              Remove
            </button>
            <widgetProgressBar
              class="progress-widget"
              v-model="file.progress"
            ></widgetProgressBar>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import VueUploadComponent from "vue-upload-component";
export default {
  name: "widget_upload",
  components: {
    FileUpload: VueUploadComponent,
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    accept: {
      type: String,
      default: "image",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    maximum: {
      type: Number,
      default: 100,
    },
    url: {
      type: String,
      default: "",
    },
    maxsize: {
      type: Number,
      default: 1024 * 1024,
    },
  },
  data() {
    return {
      files: [],
      uploaded_files: [],
    };
  },
  mounted() {},
  methods: {
    removeFile(file) {
      let vm = this;
      vm.$refs.upload.remove(file);
    },
    async customAction(file, component) {
      return await component.uploadPut(file);
    },
    AddFile() {
      let vm = this;

      setTimeout(() => {
        let file_el = document.querySelector("#" + vm.id);
        if (vm.accept == "image") {
          file_el.accept = "image/*";
        } else if (vm.accept == "video") {
          file_el.accept = "video/*";
        } else {
          file_el.accept = vm.accept;
        }
        file_el.click();
      }, 300);
    },

    inputFile(newFile, oldFile) {
      let vm = this;
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        if (newFile.xhr) {
          if (newFile.xhr.status == 201) {
            vm.uploaded_files.push(newFile.xhr.body);
          }
        }
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      let vm = this;
      if (newFile && !oldFile) {
        if (vm.files.map((item) => item.name).includes(newFile.name)) {
          return prevent();
        }
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
      }

      if (newFile && oldFile) {
        if (!newFile.version) {
          newFile.version = 0;
        }
        newFile.version++;
      }

      vm.$refs.upload.active = true;
    },
    // eslint-disable-next-line no-unused-vars
    updatetValue(_value) {
      let vm = this;
      if (vm.files.length > 0) {
        if (vm.$refs.upload && vm.$refs.upload.uploaded) {
          setTimeout(() => {
            vm.submitUploaded();
          }, 500);
        }
      }
    },
    submitUploaded() {
      let vm = this;
      vm.$emit("finish", vm.uploaded_files);
    },
    GetExt(file) {
      return /(?:\.([^.]+))?$/.exec(file)[1];
    },
    isVideo(filename) {
      return /\.(webm|mp4|mkv)$/i.test(filename);
    },
    isImage(filename) {
      return /\.(jpeg|jpe|jpg|gif|png|webp|svg)$/i.test(filename);
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.widget_upload {
  .uploads-preview {
    padding: 10px 0px;
    .uploading-list {
      display: grid;
      grid-template-columns: 23% 23% 23% 23%;
      grid-gap: 13px;
      @media screen and (max-width: 800px) {
        grid-template-columns: 32.333% 32.333% 32.333%;
      }
      .uploading-item {
        height: 100px;
        border-radius: 5px;
        border: 1px solid #ddd;
        padding: 9px;
        position: relative;
        &.error {
          border: 1px solid rgb(211, 4, 4);
        }
        &.success {
          border: 1px solid #01a2a7;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border: 1px solid #ddd;
          border-radius: 5px;
        }
        .progress-widget {
          position: absolute;
          right: 0px;
          bottom: 0px;
          left: 0px;
        }
        &.add-widget {
          border: 1px dashed #cfcfcf;
          .btn-add {
            width: 100%;
            font-size: 51px;
            border: none;
            background: #f2f2f2;
            height: 100%;
            border-radius: 5px;
          }
        }
        .btn-remove {
          position: absolute;
          bottom: 10px;
          left: 10px;
          padding: 4px;
          background: #8d38ee;
          color: #fff;
          border: none;
          font-size: 12px;
          border-radius: 3px;
        }
      }
    }
  }
}
</style>

